/*
 * @Description: 秒杀请求接口方法
 * @Author: kayvor
 * @Date: 2020-04-01 15:00:52
 * @LastEditTime: 2020-04-02 14:35:20
 * @LastEditors: kayvor
 */
import ajax from '../http/ajax'

/**
 * 获取秒杀主题信息
 * @param {*} params 参数
 * @return 略
 */
export const getSeckillInfo = params => {
    return ajax.get('getSeckillInfo', params)
}

/**
 * 获取秒杀主题商品信息
 * @param {*} params 参数
 * @return 略
 */
export const getSeckillGoodsList = params => {
    return ajax.post('getSeckillGoodsList', params)
}

/**
 * 获取秒杀主题商品信息
 * @param {*} params 参数
 * @return 略
 */
export const cancelRemind = params => {
    return ajax.get('cancelRemind', params)
}

/**
 * 获取短袖验证码
 * @param {Object} params 参数
 * @return 略
 */
export const sendSmsCaptcha = params => {
    return ajax.get('sendSmsCaptcha', params)
}

/**
 * 添加秒杀商品提醒
 * @param {Object} params 参数
 * @return 略
 */
export const seckillGoodsRemind = params => {
    return ajax.post('seckillGoodsRemind', params)
}
